const BASE_URL = "https://shehabradwan.com/api";

export default BASE_URL;